/* External */
import React from 'react';
import PropTypes from 'prop-types';

/* Components */
import ChannelImage from '../channelImage/ChannelImage';
import ChannelLine from '../channelLine/ChannelLine';
import RowAdLine from '../rowAd/RowAdLine';

/* Styles */
import './EpgChannels.scss';

function EpgChannels({
  channelLinesOffset,
  displayRows,
  isSports,
  onEpgPositionRecovery,
  schedulesEnd,
  schedulesStart,
}) {
  return (
    <div className="dtv-epg__channels-lines">
      <div className="dtv-epg__channels-images">
        {displayRows.map((displayRow) => {
          if (displayRow.kind === 'channel') {
            const { channel } = displayRow;
            return (
              <ChannelImage
                imageUrl={channel?.images?.[0]?.url || ''}
                title={channel.title}
                key={`channel-image_${channel.channelId}`}
              />
            );
          }
          return (
            <div
              key={`row-ad-slot_${displayRow.row.id}`}
              className="dtv-epg-row-ad__channel-slot"
              aria-hidden="true"
            />
          );
        })}
      </div>
      <div className="dtv-epg__channels-lines-move" style={{ left: `${channelLinesOffset}px` }}>
        {displayRows.map((displayRow) => {
          if (displayRow.kind === 'channel') {
            const { channel, epgIndex } = displayRow;
            return (
              <ChannelLine
                channelId={channel.channelId}
                epgIndex={epgIndex}
                isSports={isSports}
                key={`channel-line_${channel.channelId}`}
                onEpgPositionRecovery={onEpgPositionRecovery}
                schedules={channel.schedules}
                schedulesEnd={schedulesEnd}
                schedulesStart={schedulesStart}
              />
            );
          }
          return (
            <RowAdLine
              key={`row-ad_${displayRow.row.id}`}
              row={displayRow.row}
              horizontalOffset={channelLinesOffset}
            />
          );
        })}
      </div>
    </div>
  );
}

EpgChannels.propTypes = {
  channelLinesOffset: PropTypes.number.isRequired,
  displayRows: PropTypes.arrayOf(PropTypes.shape({
    kind: PropTypes.oneOf(['channel', 'rowAd']).isRequired,
  })).isRequired,
  isSports: PropTypes.bool,
  onEpgPositionRecovery: PropTypes.func,
  schedulesEnd: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  schedulesStart: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
};

EpgChannels.defaultProps = {
  isSports: undefined,
  onEpgPositionRecovery: undefined,
  schedulesEnd: undefined,
  schedulesStart: undefined,
};

export default EpgChannels;
